import React, { useState, useEffect } from 'react';
import axios from 'axios';
import QuestionDisplay from './QuestionDisplay';
import './QuestionReview.css';

const QuestionReview = ({ userId, progress }) => {
  const [questions, setQuestions] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState('');
  const [selectedGrade, setSelectedGrade] = useState('');

  useEffect(() => {
    fetchQuestions();
  }, [filter, selectedTopic, selectedGrade]);

  const fetchQuestions = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (filter === 'incorrect') params.append('incorrect', 'true');
      if (selectedTopic) params.append('topic', selectedTopic);
      if (selectedGrade) params.append('grade', selectedGrade);
      
      const response = await axios.get(
        `/api/metrics/review/${userId}?${params}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
      setQuestions(response.data.questions);
    } catch (err) {
      console.error('Error fetching review questions:', err);
    } finally {
      setLoading(false);
    }
  };

  const getTopics = () => {
    if (!progress || !progress.topicMastery) return [];
    return [...new Set(progress.topicMastery.map(t => t.topic))];
  };

  return (
    <div className="question-review">
      <div className="review-header">
        <h3>📝 Review Past Questions</h3>
        <div className="review-filters">
          <select 
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="all">All Questions</option>
            <option value="incorrect">Incorrect Only</option>
          </select>
          
          <select 
            value={selectedTopic}
            onChange={(e) => setSelectedTopic(e.target.value)}
          >
            <option value="">All Topics</option>
            {getTopics().map(topic => (
              <option key={topic} value={topic}>{topic}</option>
            ))}
          </select>
          
          <select 
            value={selectedGrade}
            onChange={(e) => setSelectedGrade(e.target.value)}
          >
            <option value="">All Grades</option>
            <option value="10">Grade 10</option>
            <option value="11">Grade 11</option>
            <option value="12">Grade 12</option>
          </select>
        </div>
      </div>
      
      {loading ? (
        <div className="loading">Loading questions...</div>
      ) : (
        <div className="review-questions">
          {questions.map((item, index) => (
            <div key={index} className="review-question-item">
              <div className="question-meta">
                <span className={`status ${item.correct ? 'correct' : 'incorrect'}`}>
                  {item.correct ? '✓ Correct' : '✗ Incorrect'}
                </span>
                <span>{item.topic}</span>
                <span>Grade {item.grade}</span>
                <span>{new Date(item.answeredAt).toLocaleDateString()}</span>
                <span>{item.timeSpent}s</span>
              </div>
              {item.question && (
                <QuestionDisplay 
                  question={item.question}
                  showAnswer={true}
                  userAnswer={item.userAnswer}
                />
              )}
            </div>
          ))}
          
          {questions.length === 0 && (
            <div className="empty-state">
              <p>No questions to review</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default QuestionReview;